import script from "./TradePair.vue?vue&type=script&setup=true&lang=ts"
export * from "./TradePair.vue?vue&type=script&setup=true&lang=ts"

export default script